import { log } from '@domgen/shared/utils/log';
import { PostRegistriaRequest } from '../../models/services/api/postRegistria';
import { post } from './client';

export const postRegistria = async (postRegistriaRequest: PostRegistriaRequest) => {
  try {
    return await post(`/v1/registria`, postRegistriaRequest);
  } catch (err) {
    log.error({ message: 'Fetch error', data: err });
    throw err;
  }
};
